import useMountChunk from './use-mount-chunk';

export default {
  useMountChunk,
};
